import React from 'react';
import PropTypes from 'prop-types';

function Badge({ children }) {
  return (
    <div className='badge badge-info badge-lg mb-7 p-4 text-xl font-bold'>
      {children}
    </div>
  );
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Badge;
